/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ tool: NonNullable<unknown> }} Rights_Tools_Remove_Tool_LabelInputs */



/**
* | output |
* | --- |
* | "Remove tool {tool}" |
*
* @param {Rights_Tools_Remove_Tool_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const rights_tools_remove_tool_label = /** @type {((inputs: Rights_Tools_Remove_Tool_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rights_Tools_Remove_Tool_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Tool ${i?.tool} entfernen`)
	return /** @type {LocalizedString} */ (`Remove tool ${i?.tool}`)
});